import Typography from "components/common/Typography";
import { tokens } from "styles/Tokens";

export const propertiesProgressHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true, key: "myPlanName" },
  { content: "Assignee" },
  { content: "Owner" },
  { content: "Functional area" },
  { content: "Due date", isSorting: true, key: "planDueDate" },
  { content: "Status", isSorting: true, key: "planStatus" },
  { content: "Completion Date", isSorting: true, key: "planCompletionDate" }
];

export const planProgressHeaders = [
  { content: "" },
  { content: "Inncode", isSorting: true, key: "innCode" },
  { content: "Assignee" },
  { content: "Owner" },
  { content: "Status", isSorting: true, key: "planStatus" },
  { content: "Progress" },
  {
    content: "Engagement",
    isSorting: true,
    key: "engagement",
    tooltip: (
      <div>
        <div>
          <Typography variant="label" color={tokens.Text.General.Inverse}>
            <b>High:</b> In progress
          </Typography>
        </div>
        <div>
          <Typography variant="label" color={tokens.Text.General.Inverse}>
            <b>Medium:</b> In progress & Overdue
          </Typography>
        </div>
        <div>
          <Typography variant="label" color={tokens.Text.General.Inverse}>
            <b>Low:</b> Not started
          </Typography>
        </div>
      </div>
    ),
    tooltipDirection: "top"
  },
  { content: "Priority", isSorting: true, key: "planPriority" },
  { content: "Due Date", isSorting: true, key: "planDueDate" },
  { content: "Completion Date", isSorting: true, key: "planCompletionDate" }
];
export const userPlanProgressHeaders = [
  { content: "" },
  { content: "Plan", isSorting: true, key: "myPlanName" },
  { content: "Functional area" },
  { content: "Due date", isSorting: true, key: "planDueDate" },
  { content: "Status", isSorting: true, key: "planStatus" },
  { content: "Completion Date", isSorting: true, key: "planCompletionDate" }
];
